import { ProductGroupMultiselectFilter, SideFilters, ToggleSwitch } from '@retail/components';
import { useAssortmentTFunction } from '@retail/monitoring-assortment/i18n';
import { MgSupplierItemSearchField } from '@retail/products/components';
import { useFilterOptions } from '@retail/products/context';
import { useFilters } from '@retail/products/hooks';
import { TextButton } from '@shared/components';

interface Props {
  showFilters: boolean;
  toggleVat: boolean;
  setToggleVat: (vat: boolean) => void;
}

export function MonitoringAssortmentFilterContainer({
  showFilters,
  toggleVat,
  setToggleVat,
}: Props) {
  const t = useAssortmentTFunction();
  const { productGroupHierarchy } = useFilterOptions();
  const { filters, setFilters, updateFilter, resetFilters } = useFilters([
    'searchQuery',
    'productGroupNumbers',
  ]);

  const hasActiveFilters = !!filters.searchQuery || filters.productGroupNumbers.length > 0;

  return (
    <SideFilters
      heading={t('assortment.filter')}
      showFilters={showFilters}
      sx={{ py: 1, overflow: 'auto' }}
      footer={
        hasActiveFilters && (
          <TextButton onClick={() => resetFilters()}>{t('assortment.resetFilters')}</TextButton>
        )
      }
    >
      <ToggleSwitch
        justifyContent="space-between"
        toggle={toggleVat}
        setToggle={setToggleVat}
        text={t('assortment.vat.included')}
      />
      <MgSupplierItemSearchField
        searchTerm={filters.searchQuery ?? undefined}
        onSubmitSearch={(query: string) => setFilters({ searchQuery: query })}
        isDisabled={false}
        size="small"
      />

      <ProductGroupMultiselectFilter
        productGroups={productGroupHierarchy}
        selectedProductGroups={filters.productGroupNumbers}
        selectProductGroup={(groupNumber: string) =>
          updateFilter('productGroupNumbers', groupNumber)
        }
      />
    </SideFilters>
  );
}
